import { useMediaQuery as useResponsiveMediaQuery } from 'react-responsive';

const useMediaQuery = query => {
  return useResponsiveMediaQuery({ query });
};

export default useMediaQuery;
